document.body.className = document.body.className.replace('no-js', 'js');

require('./htmx');

require('./form-errors');
require('./participation-map');
require('./video-modal.js');
require('./image-gallery.js');
require('./accordion.js');
require('./testimonial-carousel.js');
require('./counters.js');
require('./filter-form.js');
require('./site-header.js');
require('./school-lookup.js');
require('./people-card.js');
require('./select2');
require('./translate.js');
require('./resource-files.js');
